import type { KarteID } from '@/types/app'
import { debounce } from 'lodash-es'
import { computed, reactive } from 'vue'

import type { Ref } from 'vue'

type FormState = {
  comment: string
  selections: string[]
}
const karteCommentFormKVS = (() => {
  // NOTE: 永続化したいならLocalStorage使うなどすればおｋ
  // eslint-disable-next-line fp/no-let
  let data: Record<string, FormState> = {}
  const save = (key: string, value: FormState): void => {
    data = {
      ...data,
      [key]: value,
    }
  }
  const load = (key: string): FormState =>
    data[key] ?? { comment: '', selections: ['', ''] }

  return {
    load,
    save: debounce(save, 100),
  }
})()

export const useKarteCommentForm = (karteIdRef: Ref<Maybe<KarteID>>) => {
  const key = computed(() => karteIdRef.value?.toString() ?? 'default')
  const formState = reactive(karteCommentFormKVS.load(key.value))

  const karteCommentFormText = computed<string>({
    get() {
      return formState.comment
    },
    set(newText) {
      formState.comment = newText
      karteCommentFormKVS.save(key.value, formState)
    },
  })

  const karteCommentFormSelections = computed<string[]>({
    get() {
      return formState.selections
    },
    set(newSelections) {
      formState.selections = newSelections
      karteCommentFormKVS.save(key.value, formState)
    },
  })

  return {
    karteCommentFormText,
    karteCommentFormSelections,
  }
}
